import Icon from '../components/Icon.vue'

Icon.register({
  bug: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 288.9c-0.5 17.4-15.2 31.1-32.7 31.1h-55.3v16c0 21.9-4.9 42.6-13.6 61.1l60.2 60.2c12.5 12.5 12.5 32.8 0 45.3-12.5 12.5-32.8 12.5-45.3 0l-54.7-54.7c-24.8 20.1-56.3 32.1-90.6 32.1v-244c0-6.6-5.4-12-12-12h-24c-6.6 0-12 5.4-12 12v244c-34.4 0-65.9-12-90.6-32.1l-54.7 54.7c-12.5 12.5-32.8 12.5-45.3 0-12.5-12.5-12.5-32.8 0-45.3l60.2-60.2c-8.7-18.6-13.6-39.3-13.6-61.1v-16h-55.3c-17.4 0-32.2-13.7-32.7-31.1-0.5-18.1 14-32.9 32-32.9h56v-58.7l-46.6-46.6c-12.5-12.5-12.5-32.8 0-45.3 12.5-12.5 32.8-12.5 45.3 0l54.6 54.6h229.5l54.6-54.6c12.5-12.5 32.8-12.5 45.3 0 12.5 12.5 12.5 32.8 0 45.3l-46.6 46.6v58.7h56c18 0 32.5 14.8 32 32.9zM257 0c61.9 0 112 50.1 112 112h-224c0-61.9 50.1-112 112-112z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bug.js
// module id = 1122
// module chunks = 0